import templateUrl from "emun.media/media-slider.htm";
import controller from "emun.media/media-slider.controller";

export default {
  bindings: {
    realm: "@",
    shard: "@",
    media: "<?",
    results: "=?",
    mediaIds: "<?",
    exclude: "<?",
    take: "<?",
    tagCriteria: "<?",
    onMediaSelected: "&",
    search: "@",
    slidesToShow: "<",
    slidesToScroll: "<",
    arrows: "<",
    dots: "<",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
